import React, { ChangeEvent, useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';

interface Props {
  id?: string;
  label?: string;
  value: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const PriceField = ({ id = 'price-field', label = 'Price', value, onChange }: Props) => {
  const [priceFocused, setPriceFocused] = useState(false);

  return (
    <TextField
      label={label}
      id={id}
      variant="outlined"
      type="number"
      value={value}
      onChange={onChange}
      onFocus={() => setPriceFocused(true)}
      onBlur={() => setPriceFocused(false)}
      slotProps={{
        input: {
          startAdornment: (priceFocused || value) ? (
            <InputAdornment position="start">R</InputAdornment>
          ) : null,
        },
        htmlInput: { step: 1, min: 0 },
      }}
    />
  );
};

export default PriceField;
